@defer (when config.isVanillaHomePageEnabled) {
    @if (config.isVanillaHomePageEnabled) {
        <lh-home-page />
    }
}
@defer (when config.isVanillaHomePageEnabled) {
    @if (!config.isVanillaHomePageEnabled) {
        <pt-home />
    }
}
